export default "__VITE_ASSET__BtmLQGA1__"